module.exports = __webpack_public_path__ + "img/icons8-name-tag-100_75.f8f98bd0.png";